import {
    Load
} from './styles.js';

export default function Loader() {
    return (
        <Load></Load>
    );
}